import React from "react";
import Icon from "../../../components/AppIcon";

const TrekOverview = ({ trek, quickFacts = [], statistics = {} }) => {
  const highlights = trek?.highlights || [];
  const duration = trek?.duration || "N/A";
  const maxAltitude = trek?.maxAltitude || "N/A";
  const difficulty = trek?.difficulty || 0;
  const bestSeason = Array.isArray(trek?.bestSeason)
    ? trek.bestSeason.join(", ")
    : trek?.bestSeason || "N/A";
  const overview = trek?.overview || "No overview available.";

  const HIGHLIGHT_ICONS = [
    "Mountain", "Camera", "Compass", "Star", "Heart", "Sun", "MapPin", "Award"
  ];

  return (
    <div className="bg-[#fafaf7] py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-3 gap-10 items-start">
          {/* Left: Overview Content — 2/3 width */}
          <div className="lg:col-span-2">
            <div className="mb-8">
              <h2 className="section-heading text-foreground mb-3">
                <span className="text-primary">Trek</span> Overview
              </h2>
              <div className="w-16 h-1 bg-accent rounded-full" />
            </div>

            <div className="prose prose-lg text-text-secondary mb-10 leading-relaxed">
              <p>{overview}</p>
            </div>

            {/* Trek Highlights */}
            <div>
              <h3 className="font-headline text-2xl font-semibold text-foreground mb-6">
                Trek Highlights
              </h3>
              <div className="grid sm:grid-cols-2 gap-4">
                {highlights?.map((highlight, index) => (
                  <div
                    key={index}
                    className="flex items-start gap-4 p-4 bg-white rounded-xl border border-border/50 hover:border-accent/30 hover:shadow-sm transition-all duration-200"
                  >
                    <div className="w-10 h-10 rounded-xl bg-accent/10 flex items-center justify-center flex-shrink-0">
                      <Icon
                        name={HIGHLIGHT_ICONS[index % HIGHLIGHT_ICONS.length]}
                        size={18}
                        className="text-accent"
                      />
                    </div>
                    <span className="text-text-secondary text-sm leading-relaxed pt-1">
                      {highlight}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right: Quick Facts — 1/3 width, sticky */}
          <div className="lg:col-span-1 lg:sticky lg:top-24">
            <div className="bg-white rounded-2xl border border-border/50 shadow-sm overflow-hidden">
              <div className="bg-primary px-6 py-4">
                <h3 className="font-headline font-semibold text-white text-lg flex items-center gap-2">
                  <Icon name="Info" size={18} />
                  Quick Facts
                </h3>
              </div>
              <div className="p-6 space-y-0 divide-y divide-border/50">
                <div className="flex items-center justify-between py-4 first:pt-0">
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center">
                      <Icon name="Calendar" size={16} className="text-primary" />
                    </div>
                    <span className="font-medium text-foreground text-sm">Duration</span>
                  </div>
                  <span className="text-text-secondary text-sm font-semibold">{duration} Days</span>
                </div>

                <div className="flex items-center justify-between py-4">
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center">
                      <Icon name="TrendingUp" size={16} className="text-primary" />
                    </div>
                    <span className="font-medium text-foreground text-sm">Max Altitude</span>
                  </div>
                  <span className="text-text-secondary text-sm font-semibold">{maxAltitude}</span>
                </div>

                <div className="flex items-center justify-between py-4">
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center">
                      <Icon name="Activity" size={16} className="text-primary" />
                    </div>
                    <span className="font-medium text-foreground text-sm">Difficulty</span>
                  </div>
                  <div className="flex items-center gap-1">
                    {[1, 2, 3, 4, 5].map((i) => (
                      <Icon
                        key={i}
                        name="Star"
                        size={14}
                        className={i <= difficulty ? "text-accent" : "text-gray-200"}
                      />
                    ))}
                  </div>
                </div>

                <div className="flex items-center justify-between py-4">
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center">
                      <Icon name="Thermometer" size={16} className="text-primary" />
                    </div>
                    <span className="font-medium text-foreground text-sm">Best Season</span>
                  </div>
                  <span className="text-text-secondary text-sm font-semibold text-right">{bestSeason}</span>
                </div>


              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrekOverview;
